const ToastSelectors = {
  getToasts(store) {
    return store?.toasts;
  },
};

export { ToastSelectors };
